/**
 * Brand film: the stage is the theme's `deferred-media` element. Its poster is
 * the "play" button in the copy column; on click the element clones the full
 * film out of its template and plays it. This script does the rest: it pauses
 * the ambient loop while the film runs, marks the stage as playing so the copy
 * and the scrim step aside, and restores the loop when the film ends or the
 * visitor closes it (button or Escape). Closing removes the film element and
 * the `loaded` flag, so the next click starts the film fresh. The film always
 * plays inline in the page, on phones in the media box above the copy.
 */
const stages = document.querySelectorAll('.brand-film__stage');

stages.forEach((stage) => {
  const section = stage.closest('.brand-film');
  const loop = stage.querySelector('.brand-film__video video');
  const close = stage.querySelector('.brand-film__close');
  const poster = stage.querySelector('.brand-film__play');
  if (!section || !poster) return;

  const film = () => stage.querySelector(':scope > video');

  const stop = () => {
    const playing = film();
    if (playing) {
      playing.pause();
      playing.remove();
    }
    stage.removeAttribute('loaded');
    section.classList.remove('brand-film--playing');
    if (close) close.hidden = true;
    if (loop && loop.paused && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const resumed = loop.play();
      if (resumed && typeof resumed.catch === 'function') resumed.catch(() => {});
    }
    poster.focus();
  };

  const start = () => {
    const playing = film();
    if (!playing) return;
    if (loop) loop.pause();
    section.classList.add('brand-film--playing');
    if (close) close.hidden = false;
    playing.addEventListener('ended', stop, { once: true });
    // Safari does not fetch the <source> children of a video cloned out of a
    // template while preload is "none"; load() makes it read them.
    if (playing.readyState === 0) playing.load();
    const started = playing.play();
    if (started && typeof started.catch === 'function') started.catch(() => {});
    playing.scrollIntoView({ block: 'nearest' });
  };

  // deferred-media registered its click handler first (global.js loads before
  // this module), so the film is already in the stage when this one runs.
  // Stay inside the click event: Safari only allows play() with sound and
  // fullscreen while the user gesture is active.
  poster.addEventListener('click', start);

  if (close) close.addEventListener('click', stop);

  stage.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && film()) {
      event.preventDefault();
      stop();
    }
  });
});
